export default obj => {
  return Object.keys(obj).map(key => {
    let match = obj[key];
    let newObj = Object.assign({}, match);
    newObj.id = key;
    return newObj;
  });
}



// WEBPACK FOOTER //
// ./src/utils/arrayify.js